import React from 'react'

function Input({ className = '', ...props }) {
  return (
    <input
      type="text"
      {...props}
      className={`h-[40px] focus:outline-none rounded-[4px] font-semibold placeholder-[rgba(61,66,86,.6)] text-[rgba(61,66,86,.6)] border-[1px] border-solid border-[#C7CCD9] bg-[#fafafa] px-[16px] py-[10px] text-[16px] lg:text-[14px] ${className} `}
    />
  )
}

export default Input
